import Spinner from 'components/Spinner/Spinner'
import { useUserPostsQuery } from 'graphql/generated/graphql'
import React from 'react'
import PostInfo from './PostInfo'

export default function UserPosts(): JSX.Element {
  const { data, error, loading, refetch } = useUserPostsQuery()
  if (loading) {
    return <Spinner />
  }
  if (error) {
    console.log(error)
    return (
      <div>
        <p>Something went wrong please try again later!</p>
      </div>
    )
  }
  return (
    <div>
      <div>
        <h2>Scheduled Posts:</h2>
        <hr />
        {data?.userPosts.scheduled.length ? (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            {data.userPosts.scheduled.map((post) => {
              return (
                <PostInfo
                  key={post?.id}
                  data={post}
                  scheduled={true}
                  refetch={refetch}
                />
              )
            })}
          </div>
        ) : (
          <p style={{ padding: '20px 0' }}>
            Currently there is no scheduled posts. If you want to schedule a
            post{' '}
            <a href="/post" style={{ color: '#96EFFF' }}>
              click here
            </a>
            .
          </p>
        )}
      </div>
      <div>
        <h2>Previous Posts:</h2>
        <hr />
        {data?.userPosts.old.length ? (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            {data.userPosts.old.map((post) => {
              return (
                <PostInfo
                  key={post?.id}
                  data={post}
                  scheduled={false}
                  refetch={refetch}
                />
              )
            })}
          </div>
        ) : (
          <p style={{ padding: '20px 0' }}>
            You haven&apos;t created any post via our application. If you want
            to create a post{' '}
            <a href="/post" style={{ color: '#96EFFF' }}>
              click here
            </a>
            .
          </p>
        )}
      </div>
    </div>
  )
}
